<!--suppress CssInvalidPseudoSelector -->
<template>
  <aside class="layout_aside full-width full-height" v-loading.lock="isAsideLoading">
    <!-- start: panel -->
    <div class="aside-top flex flex-middle" v-height="50">
      <span style="font-size: 14px; padding-left: 6px; min-width:190px;">实例: {{instanceName}}</span>
    </div>

    <!-- start: collapse -->
    <!-- 临时添加一个标识，用于表明下方是数据表。未来可能会做成折叠面板 -->
    <div class="panel flex flex-middle flex-between" v-height="40">
      <!--<i class="collapse-icon el-icon-ali-table"></i>
      <span class="collapse-title">数据表</span>-->
      <!--<el-button size="mini" type="primary" @click="onCreateDatabase">新建数据库</el-button>-->
      <el-button
        class="panel-button"
        size="small"
        icon="el-icon-refresh"
        @click="getDatabases"
      ></el-button>
    </div>
    <!-- end: collapse -->

    <!-- start: tree -->
    <div
      class="tree-wrapper"
      v-height="$store.state.size.heightHomeMain - 50 - 40"
      @contextmenu.prevent>
      <el-tree
        highlight-current
        class="tree el-tree-highlighter"
        node-key="id"
        icon-class="hidden"
        ref="tableTree"
        :data="filteredTableTree"
        :props="treeProps"
        @node-click="handleNodeClick">
        <template #default="{ node, data }">
          <tree-node
            v-if="data.belong === 'DATABASES'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'TABLE'"
            v-contextmenu:contextmenuTable
            :node="node"
          ></tree-node>
          <span v-else>未知节点</span>
        </template>
      </el-tree>
    </div>
    <!-- end: tree -->

    <!-- start: contextmenus -->
    <v-contextmenu
      ref="contextmenuTable"
      @contextmenu="vnode => handleNodeContextmenu(vnode, 'contextmenuTable')"
    >
      <v-contextmenu-item @click="onOpenTableView" ref="contextmenu">打开表</v-contextmenu-item>
    </v-contextmenu>
    <!-- end: contextmenus -->

    <!-- start: 新建数据库弹窗 -->
    <database-creator ref="databaseCreator" @submit="handleDatabaseCreated"></database-creator>
    <!-- end: 新建数据库弹窗 -->

  </aside>
</template>

<script>
// api
import {
  reqExecSql,
} from '@/api/jdbc';

// tree-nodes
import TreeNode from '@/views/common/TreeNode';
// libs
import {
  directive as VContextmenuDirective,
  Contextmenu as VContextmenu,
  ContextmenuItem as VContextmenuItem
} from 'v-contextmenu/src';
import DatabaseCreator from './features/DatabaseCreator';
import Store from '@/store/';

class ITreeNodeDatabases {
  constructor({id, databaseName}) {
    this.id = id;
    this.databaseName = databaseName;
    this.label = databaseName;
    this.isLeaf = false;
    this.belong = 'DATABASES';
    this.logo = 'folder-2';
    this.logoSize = 18;
    this.children = [];
  }
}

class ITreeTable {
  constructor({ id, tableName, databaseName }) {
    this.id = id + '';
    this.label = tableName;
    this.databaseName = databaseName;
    this.children = [];
    this.queried = false;
    this.isLeaf = true;
    this.belong = 'TABLE';
    this.tableName = tableName;
    this.logo = 'table';
    this.logoSize = 18;
  }
}

export default {
  name: 'HomeAside',

  components: {
    VContextmenu,
    VContextmenuItem,
    TreeNode,
    DatabaseCreator,
  },

  directives: {
    contextmenu: VContextmenuDirective
  },

  data() {
    return {
      currentDatabase: '',
      isAsideLoading: false,
      tableTree: [],
      filteredTableTree: [],
      treeProps: { label: 'label', children: 'children', disabled: 'disabled', isLeaf: 'isLeaf' },
      throttledFilterTableTreeNode: null,
      contextmenuItemDisabled: {
        deleteIndex: false
      },
      instanceName: ''
    };
  },

  computed: {
    currentTreeNodeData() {
      return this.$refs.tableTree.getCurrentNode();
    }
  },

  created() {
    this.instanceName = Store.state.source.sourceInfo.instanceName;
    this.getDatabases();
  },

  methods: {
    /**
     * =============================================================
     * 侧边栏
     * =============================================================
     */
    /**
     * 左键点击树的节点，首先设置节点被选中。如果节点是表并且节点还没有拉取过信息，则拉取表信息
     */
    async handleNodeClick(data, node) {
      this.$refs.contextmenuTable.hide();
      this.$refs.tableTree.setCurrentKey(data.id);
      if(data.belong === 'DATABASES' && !data.queried) this.queryDatabasesInfo(node);
    },
    handleDatabaseCreated(result) {
      if (result) {
        this.getDatabases();
      }
    },
    /**
     * 出现右键菜单时，通过 vnode 获取到被点击的树节点的信息，设置树节点激活
     */
    async handleNodeContextmenu(vnode, ref) {
      // 关闭其他右键菜单
      ['contextmenuTable'].map(item => {
        if (item !== ref) this.$refs[item].hide();
      });

      const node = vnode.componentInstance.node;
      this.$refs.tableTree.setCurrentKey(node.data.id);
    },
    /**
     * 懒加载查询数据库下的表
     */
    async queryDatabasesInfo(node) {
      try {
        this.isAsideLoading = true;
        const data = node.data;
        let sqlStr = `show tables in ${data.label}`;

        // 获取表名
        let databasesArr = await this.procResult(sqlStr);
        let databaseName = data.databaseName;
        let parentId = data.id;
        data.children = databasesArr.map(
          (table, index) =>
            new ITreeTable({
              id: parentId + '_' + index,
              tableName: table,
              databaseName: databaseName
            })
        );

        // 设置一级节点展开
        node.expanded = true;
        // 设置当前节点为已查询过表结构，保证下一次打开不会再查询
        data.queried = true;
      } finally {
        this.isAsideLoading = false;
      }
    },

    async procResult(sqlStr) {
      let tempTree = [];
      try {
        const res = await reqExecSql(sqlStr);
        if(res.data.code === 'success'){
          let tempKey = res.data.data.Result[0].ResultCols[0];
          let tempResult = res.data.data.Result[0].ResultSet;
          if(tempResult){
            tempTree = tempResult.map(item => {
              return item[tempKey]
            });
          }
        }
        /*else if(res.data.code === 'fail.param.error.ConnToken')
        {
          const sourceInfo = Store.state.source.sourceInfo;
          //toLogin(this.$router, sourceInfo);
        }*/
      } finally {
        this.isAsideLoading = false;
      }
      return tempTree;
    },
    /**
     * 获取数据库选项列表
     */
    async getDatabases() {
      let tempTree = await this.procResult('show DATABASES');
      this.filteredTableTree = this.tableTree = tempTree.map((item, index) =>{
        return new ITreeNodeDatabases({
          id: index,
          databaseName: item
        });
      });
    },

    /**
     * =============================================================
     * 右键菜单绑定的功能
     * =============================================================
     */
    /**
     * 打开表
     */
    onOpenTableView() {
      let database = this.$refs.contextmenu.$parent.$parent.currentTreeNodeData.databaseName;
      this.$router.push({
        name: 'JdbcTableView',
        query: {
          db_sign: this.$route.query.db_sign,
          database: database,
          table: this.currentTreeNodeData.tableName,
          key: +new Date()
        }
      });
    },
    /**
     * 新建数据库
     */
    onCreateDatabase() {
      this.$refs.databaseCreator.open();
    },
  }
};
</script>

<style lang="scss" scoped>
// $height-tree-node: 22px;

.layout_aside {
  min-height: 0;
  min-width: 0;

  .aside-top{
    background-color: #e4e7ed;
    padding-left: 4px;
    padding-right: 4px;
  }

  .panel {
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
    color: #333;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    &-button {
      margin-left: 6px;
    }
  }

  .filter {
    overflow: hidden;
  }

  // 解决出现横向滚动条后隐藏超出部分的问题
  .tree-wrapper {
    max-width: 100%;
    overflow: auto;
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: #fff;
  }

  .tree {
    min-width: 100%;
    display: inline-block;

    &::v-deep .el-tree-node {
      .el-tree-node__content {
        // height: $height-tree-node !important;
        display: flex;
        align-items: center;
      }
    }
  }
}

.table_tree_icon {
  display: none;
}
</style>
